import React from "react";

import { Box, Stack } from "@mui/material";

import { manual } from "utils/virtualTour";

import VerticalText from "../VerticalText";

import ControlsCard from "./components/ControlsCard";
import ViewCards from "./components/ViewCards";
import styles from "./styles";
import { useAtomValue } from "jotai";
import { isUnityViewerFullScreenAtom } from "store/atoms/isUnityViewerFullScreen";

const ViewControlCard = () => {
  const fullscreen = useAtomValue(isUnityViewerFullScreenAtom);
  return (
    <Stack sx={styles.container}>
      <Stack sx={{ ...styles.cardContainer, flex: 0.75 }}>
        <VerticalText text="VIEWS" />
        <ViewCards />
      </Stack>
      <Stack sx={{ ...styles.cardContainer, flex: 1 }}>
        <Stack
          sx={{
            gap: fullscreen
              ? 3
              : {
                  xs: 1,
                  md: 0,
                  lg: 1,
                },
            flex: 1,
            flexGrow: 1,
          }}
        >
          <ControlsCard {...manual} />
        </Stack>
        <VerticalText text="CONTROLS" />
      </Stack>
    </Stack>
  );
};

export default ViewControlCard;
